[
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    26,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    -8,
    -8
  ],
  [
    -8,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -8
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    -8,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -8
  ],
  [
    -8,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -8
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    -8,
    -8
  ],
  [
    -8,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -8
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -8
  ],
  [
    -8,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -7
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -7
  ],
  [
    0,
    -9
  ],
  [
    0,
    -12
  ],
  [
    -6,
    -22
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    2
  ],
  [
    2,
    0
  ],
  [
    2,
    0
  ],
  [
    2,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    2
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    2
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    3,
    3
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    2,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    2,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    5,
    6
  ],
  [
    0,
    4
  ],
  [
    0,
    8
  ],
  [
    0,
    9
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    2
  ],
  [
    2,
    0
  ],
  [
    0,
    25
  ],
  [
    0,
    -2
  ],
  [
    2,
    0
  ],
  [
    0,
    -2
  ],
  [
    0,
    28
  ],
  [
    12,
    26
  ],
  [
    5,
    7
  ],
  [
    0,
    0
  ],
  [
    0,
    2
  ],
  [
    21,
    3
  ],
  [
    19,
    0
  ],
  [
    7,
    -2
  ],
  [
    0,
    0
  ],
  [
    3,
    10
  ],
  [
    3,
    19
  ],
  [
    2,
    2
  ],
  [
    7,
    2
  ],
  [
    26,
    3
  ],
  [
    5,
    0
  ],
  [
    0,
    2
  ],
  [
    0,
    11
  ],
  [
    18,
    12
  ],
  [
    -2,
    9
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    -4,
    -2
  ],
  [
    0,
    0
  ],
  [
    -2,
    0
  ],
  [
    2,
    -4
  ],
  [
    0,
    0
  ],
  [
    6,
    -4
  ],
  [
    2,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    6,
    6
  ],
  [
    0,
    0
  ],
  [
    -6,
    -2
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    3,
    -2
  ],
  [
    -2,
    -3
  ],
  [
    -7,
    -3
  ],
  [
    0,
    0
  ],
  [
    5,
    3
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ]
]